import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'block-user-for-dependent');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'impersonated_users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['dependentId'],
    },
    'chat',
    'blocked_users',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/board/block-user-for-dependent.js